import { getLangFromUrl } from 'Translator';
import { useLocation } from 'react-router-dom';

function usePathnameWithNoLangCode() {
  const { pathname } = useLocation();
  const langCode = getLangFromUrl();

  if (langCode !== 'en') {
    return pathname.replace(`/${langCode}`, '');
  }
  return pathname;
}

export default usePathnameWithNoLangCode;
